import PropTypes from "prop-types";
import React from "react";
export const setActiveSort = e => {
  const filterButtons = document.querySelectorAll(
    ".sidebar-widget-list-left button, .sidebar-widget-tag button, .product-filter button"
  );
  filterButtons.forEach(item => {
    item.classList.remove("active");
  });
  e.currentTarget.classList.add("active");
};

export const setSubActiveSort = e => {
  const filterButtons = document.querySelectorAll(
    ".sidebar-widget-list-left li button"
  );
  filterButtons.forEach(item => {
    item.classList.remove("active");
  });
  e.currentTarget.classList.add("active");
};


const ShopCategories = ({ categories, setCategoryParams, setSubCategoryParams }) => {
  return (
    <div className="sidebar-widget">
      <h4 className="pro-sidebar-title">Categories </h4>
      <div className="sidebar-widget-list mt-3">
        {categories ? (
          <ul>
            <li>
              <div className="sidebar-widget-list-left">
                <button
                  onClick={e => {
                    setCategoryParams("");
                    setActiveSort(e);
                  }}
                >
                  <span className="checkmark" /> All Categories
                </button>
              </div>
            </li>
            {categories.map((category, key) => {
              return (
                <li key={key}>
                  <div className="sidebar-widget-list-left">
                    <button
                      onClick={e => {
                        setCategoryParams(category.category_id);
                        setActiveSort(e);
                      }}
                    >
                      {" "}
                      <span className="checkmark" /> {category.name}{" "}
                    </button>
					<ul className="sub_categories">
					{typeof setSubCategoryParams!=='undefined' ? category.sub_categories.map((sub_category,ind)=>{
						return <li key={key}>
						  
							<button
							  onClick={e => {
								setSubCategoryParams(sub_category.category_id);
								setSubActiveSort(e);
							  }}
							>
							  {" "}
							  <span className="checkmark" /> {sub_category.name}{" "}
							</button>
						</li>
					}):""}
					</ul>
                  </div>
                </li>
              );
            })}
          </ul>
        ) : (
          "No categories found"
        )}
      </div>
    </div>
  );
};

ShopCategories.propTypes = {
  categories: PropTypes.array,
  setCategoryParams: PropTypes.func
};

export default ShopCategories;
